import type {
  GuardianInvitationAction,
  GuardianInvitationPreview,
} from '@/features/guardian/types/invitation';
import { buildUrl, usKidsGolfService } from '@/libs/api/instances/us-kids-golf-instance';

const invitationUrl = (token: string) => buildUrl(`/invitations/${encodeURIComponent(token)}`);

export async function fetchGuardianInvitation(token: string, skipAuth = false) {
  return await usKidsGolfService.get<GuardianInvitationPreview>(invitationUrl(token), undefined, {
    skipAuth,
    skipServerErrorAlert: true,
  });
}

export async function acceptGuardianInvitation(token: string) {
  return await usKidsGolfService.post<GuardianInvitationAction>(
    `${invitationUrl(token)}/accept`,
    undefined,
    { skipServerErrorAlert: true },
  );
}

export async function declineGuardianInvitation(token: string) {
  return await usKidsGolfService.post<GuardianInvitationAction>(
    `${invitationUrl(token)}/decline`,
    undefined,
    { skipServerErrorAlert: true },
  );
}
